import React from "react";

function formatActorNames(actors) {
  const names = (actors || []).map((a) => a.name).filter(Boolean);
  if (names.length === 0) return "Someone";
  if (names.length === 1) return names[0];
  if (names.length === 2) return `${names[0]} and ${names[1]}`;
  return `${names[0]}, ${names[1]} and ${names.length - 2} others`;
}

export function ActionSentence({ type, actorName, noteId, noteTitle, message, read, actors }) {
  const base = read
    ? "text-sm leading-5 text-text-primary line-clamp-1 pr-16"
    : "text-sm leading-5 text-text-primary font-semibold line-clamp-1 pr-16";

  if (type === "nearby_note") {
    // Personalized (has noteId): "{actorName} left a trace near you"
    // Legacy bulk (no noteId): show "New Nearby Notes"
    if (noteId) {
      return (
        <p className={base}>
          <span
            className={
              read ? "font-semibold text-text-primary" : "font-bold text-text-primary"
            }
          >
            {actorName || "Someone"}
          </span>{" "}
          left a trace near you
        </p>
      );
    }
    return (
      <p className={base}>
        <span
          className={
            read ? "font-semibold text-text-primary" : "font-bold text-text-primary"
          }
        >
          {message ? "New Nearby Notes" : "New note nearby"}
        </span>
      </p>
    );
  }

  const primaryActorText =
    actors && actors.length > 1
      ? formatActorNames(actors)
      : actorName || "Someone";

  return (
    <p className={base}>
      <span
        className={
          read ? "font-semibold text-text-primary" : "font-bold text-text-primary"
        }
      >
        {primaryActorText}
      </span>{" "}
      {type === "like" && <>liked your note</>}
      {type === "comment" && <>commented on your note</>}
      {type === "comment_like" && <>liked your comment</>}
    </p>
  );
}
